module.exports = __webpack_public_path__ + "img/home-part-a.bb0a2f96.png";